import { useEffect, useRef, useState } from "react";
import { noDataMFFound } from "../../CommonMethhods/CommonMethods";
function MTFPMRReportTable(props) {
    const { tableData, handleTableScroll } = props;
    const [hasVerticalScroll, setHasVerticalScroll] = useState(false);
    const tableBodyRef = useRef(null);

    console.log(tableData, "data");
    useEffect(() => {
        const el = tableBodyRef.current;
        if (!el) return;
        const checkScroll = () => {
            setHasVerticalScroll(el.scrollHeight > el.clientHeight);
        };
        checkScroll();
        const observer = new ResizeObserver(checkScroll);
        observer.observe(el);

        return () => observer.disconnect();
    }, [tableData]);

    return (
        <div>
            <div className="table-responsive scroll-table report-table-wrapper tax-table">
                <h2 style={{ textAlign: "start", fontSize: "15px", fontWeight: "500", marginBottom: "15px" }}>Client MTF Report</h2>
                <div className="table-responsive scroll-table report-table-wrapper tax-table">
                    {tableData?.mtfList?.length > 0 ? <>
                        <table className="table bordered-table" style={{ width: "200%" }}>
                            <thead>
                                <tr>
                                    <th>Client Code</th>
                                    <th>Client Name</th>
                                    <th>MTF Ledger Amount</th>
                                    <th>Funded Stock Value</th>
                                    <th>Margin Required</th>
                                    <th>MTM Loss</th>
                                    <th>Total Margin Required</th>
                                    <th>Cash Margin Maintain</th>
                                    <th>MTF Cash Eq. Collateral</th>
                                    <th>MTF Non-Cash Collateral</th>
                                    <th>Total MTF Collateral</th>
                                    <th>Shortfall</th>
                                    {tableData?.mtfList.length > 3 ? <th className="scroll-th"></th> : null}
                                    {/* {hasVerticalScroll && <th className="scrollerthead"></th>} */}
                                </tr>
                            </thead>
                            <tbody
                            // onScroll={(e) => handleScroll(e)}
                            // id="per-table-body"
                            >
                                {tableData?.mtfList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.clientCode?.trim() || "-"}</td>
                                        <td>{item?.clientName || "-"}</td>
                                        <td>{item?.mtfLedAmt?.toLocaleString() || 0}</td>
                                        <td>{item?.fundStockVal?.toLocaleString() || 0}</td>
                                        <td>{item?.marginRequired?.toLocaleString() || 0}</td>
                                        <td>{item?.mtomLoss?.toLocaleString() || 0}</td>
                                        <td>{item?.totalMarginRequired?.toLocaleString() || 0}</td>
                                        <td>{item?.marginMaintainance?.toLocaleString() || 0}</td>
                                        <td>{item?.mtfCashEqCollateral?.toLocaleString() || 0}</td>
                                        <td>{item?.mtfNonCashCollateral?.toLocaleString() || 0}</td>
                                        <td>{item?.totalMTFCollateral?.toLocaleString() || 0}</td>
                                        <td>{item?.shortfall?.toLocaleString() || 0}</td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    </> :
                        (
                            <h4 className="report-error-message">
                                {noDataMFFound("MTF Report report does not exist.")}
                            </h4>
                        )
                    }
                </div>
            </div>
            <div className="table-responsive scroll-table report-table-wrapper tax-table">
                <h2 style={{ textAlign: "start", fontSize: "15px", fontWeight: "500", marginBottom: "15px" }}>Client Position Report</h2>
                {tableData?.positionList?.length > 0 ? <>
                    <table className="table bordered-table" style={{ width: "150%" }}>
                        <thead>
                            <tr>
                                <th>Scrip Name</th>
                                <th>ISIN</th>
                                <th>Quantity</th>
                                <th>Funded Value</th>
                                <th>Closing Rate</th>
                                <th>Market Value</th>
                                <th>Haircut (%)</th>
                                <th>Margin Required</th>
                                <th>MTM Loss</th>
                                <th>Final Margin Required</th>
                                {tableData.positionList.length > 4 ? <th className="scroll-th"></th> : null}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.positionList?.filter((item) => item?.scripName !== "TOTAL") // exclude TOTAL from main table
                                .map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.scripName || "-"}</td>
                                        <td>{item?.isin || "-"}</td>
                                        <td>{item?.qty?.toLocaleString() || 0}</td>
                                        <td>{item?.fundedValue?.toLocaleString() || 0}</td>
                                        <td>{item?.clRate?.toLocaleString() || 0}</td>
                                        <td>{item?.mktValue?.toLocaleString() || 0}</td>
                                        <td>{item?.hairCut?.toLocaleString() || 0}</td>
                                        <td>{item?.marginRequired?.toLocaleString() || 0}</td>
                                        <td>{item?.mtomLoss?.toLocaleString() || 0}</td>
                                        <td>{item?.finalMarginRequired?.toLocaleString() || 0}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    {/* Fixed TOTAL row as separate table */}
                    {tableData?.positionList?.find((item) => item?.scripName === "TOTAL") && (
                        <table
                            className="table bordered-table final"
                            style={{ width: "150%", position: "sticky", bottom: 0, background: "#fff" }}
                        >
                            <tbody>
                                <tr style={{ fontWeight: "bold", backgroundColor: "#f1f1f1" }}>
                                    <td>{tableData.positionList.find((item) => item?.scripName === "TOTAL")?.scripName}</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>{tableData.positionList.find((item) => item?.scripName === "TOTAL")?.fundedValue?.toLocaleString()}</td>
                                    <td>-</td>
                                    <td>{tableData.positionList.find((item) => item?.scripName === "TOTAL")?.mktValue?.toLocaleString()}</td>
                                    <td>-</td>
                                    <td>{tableData.positionList.find((item) => item?.scripName === "TOTAL")?.marginRequired?.toLocaleString()}</td>
                                    <td>-</td>
                                    <td>{tableData.positionList.find((item) => item?.scripName === "TOTAL")?.finalMarginRequired?.toLocaleString()}</td>
                                    {tableData.positionList.length > 4 ? <td className="scroll-th"></td> : null}
                                </tr>
                            </tbody>
                        </table>
                    )}
                </> : (
                    <h4 className="report-error-message">
                        {noDataMFFound("Position Report report does not exist.")}
                    </h4>
                )}

            </div>
            <div className="table-responsive scroll-table report-table-wrapper tax-table">
                <h2 style={{ textAlign: "start", fontSize: "15px", fontWeight: "500", marginBottom: "15px" }}>Client Collateral Report</h2>
                {tableData?.collateralList?.length > 0 ? <>
                    <table className="table bordered-table" style={{ width: "120%" }}>
                        <thead>
                            <tr>
                                <th>Scrip Name</th>
                                <th>ISIN</th>
                                <th>Quantity</th>
                                <th>Closing Rate</th>
                                <th>Market Value</th>
                                <th>Haircut (%)</th>
                                <th>Net Value</th>
                                {tableData?.collateralList?.length > 5 ? <th className="scroll-th"></th> : null}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData?.collateralList
                                ?.filter((item) => item?.scripName !== "TOTAL") // exclude TOTAL row
                                .map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.scripName || "-"}</td>
                                        <td>{item?.isin || "-"}</td>
                                        <td>{item?.qty?.toLocaleString() || 0}</td>
                                        <td>{item?.clRate?.toLocaleString() || 0}</td>
                                        <td>{item?.mktValue?.toLocaleString() || 0}</td>
                                        <td>{item?.haircut?.toLocaleString() || 0}</td>
                                        <td>{item?.netValue?.toLocaleString() || 0}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    {/* Fixed TOTAL row as separate summary table */}
                    {tableData?.collateralList?.find((item) => item?.scripName === "TOTAL") && (
                        <table
                            className="table bordered-table final"
                            style={{
                                width: "120%",
                                marginTop: "0px",
                                position: "sticky",
                                bottom: 0,
                                background: "#fff",
                                zIndex: 5,
                            }}
                        >
                            <tbody>
                                <tr style={{ fontWeight: "bold", backgroundColor: "#f1f1f1" }}>
                                    <td>{tableData.collateralList.find((i) => i?.scripName === "TOTAL")?.scripName}</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>{tableData.collateralList.find((i) => i?.scripName === "TOTAL")?.mktValue?.toLocaleString()}</td>
                                    <td>-</td>
                                    <td>{tableData.collateralList.find((i) => i?.scripName === "TOTAL")?.netValue?.toLocaleString()}</td>
                                      {tableData.collateralList.length > 5 ? <td className="scroll-th"></td> : null}
                                </tr>
                            </tbody>
                        </table>
                    )}
                </> : (
                    <h4 className="report-error-message">
                        {noDataMFFound("Collateral Report report does not exist.")}
                    </h4>
                )}



            </div>
        </div>
    );
}
export default MTFPMRReportTable;
